import React from 'react';
import { GridReactContextProvider } from '../../../Utils/DataGridWrapper/GridContext';
import { PendingApprovalsTable } from './PendingApprovalsTable/PendingApprovalsTable';
import { useUserAdminOrgs } from '../../Hooks/UseUserAdminOrgs';
import './PendingApprovals.scss';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';

/**
 * Container component for Pending Approvals (Document Uploads) with organization context
 */
export const PendingApprovals = () => {
    const {
        adminOrganizationOptions,
        isOrgsLoading
    } = useUserAdminOrgs({ withAllOption: true, withCoursesAndSignDocs: false });

    if (isOrgsLoading) {
        return <LoadingSpinner />;
    }

    return (
        <GridReactContextProvider>
            <div className="pending-approvals-container">
                <PendingApprovalsTable
                    organizationsOptions={adminOrganizationOptions}
                />
            </div>
        </GridReactContextProvider>
    );
};
